import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=41410e78&"
import script from "./Candidate.vue?vue&type=script&lang=js&"
export * from "./Candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports